import { render, staticRenderFns } from "./whoDialog.vue?vue&type=template&id=dd8154b6"
import script from "./whoDialog.vue?vue&type=script&lang=js"
export * from "./whoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports